var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { INLINE_STYLES } from '../helper';
var IconS24Telephone48 = function (_a) {
    var inline = _a.inline, title = _a.title, rest = __rest(_a, ["inline", "title"]);
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 32 32", fill: "currentColor" }, rest, { style: __assign(__assign({}, (inline && INLINE_STYLES)), rest.style) }),
        title && React.createElement("title", null, title),
        React.createElement("path", { d: "M19.333 28.667c-0.005 0-0.011 0-0.017 0-2.401 0-4.573-0.976-6.143-2.553l-0-0-7.287-7.253c-1.578-1.577-2.554-3.756-2.554-6.163s0.976-4.586 2.554-6.163l0-0 3.173-3.2 7.607 7.633-2.787 2.787c-0.242 0.241-0.391 0.575-0.391 0.943s0.149 0.702 0.391 0.943v0l2.507 2.5c0.241 0.24 0.573 0.388 0.94 0.388s0.699-0.148 0.94-0.388l-0 0 2.793-2.807 7.607 7.633-3.18 3.173c-1.567 1.561-3.729 2.527-6.117 2.527-0.013 0-0.026-0-0.039-0h0.002zM9.060 5.247l-2.233 2.227c-1.335 1.336-2.16 3.182-2.16 5.22s0.825 3.884 2.16 5.22l7.287 7.287c1.336 1.335 3.182 2.16 5.22 2.16s3.884-0.826 5.22-2.16l2.233-2.233-5.727-5.72-1.84 1.84c-0.483 0.483-1.15 0.782-1.887 0.782s-1.404-0.299-1.887-0.782l-2.507-2.507c-0.483-0.483-0.782-1.15-0.782-1.887s0.299-1.404 0.782-1.887l0-0 1.847-1.84z" })));
};
export default IconS24Telephone48;
//# sourceMappingURL=IconS24Telephone48.js.map